const i = {
  all: "unset",
  position: "relative",
  cursor: "pointer",
  bg: "lightGray3",
  transition: "all",
  ":hover": {
    opacity: 0.8
  },
  ":active": {
    opacity: 1
  },
  ":focus-visible": (t) => ({
    ...t.outline()
  }),
  '&[data-state="checked"]': {
    bg: "primary"
  },
  ":disabled": {
    cursor: "default",
    pointerEvents: "none",
    bg: "stroke"
  }
}, e = {
  display: "block",
  bg: "white",
  borderRadius: "50%",
  transition: "all",
  transform: (t) => `translateX(${t.spacing(0.75)})`,
  willChange: "transform",
  "&[data-disabled]": {
    bg: "lightGray3"
  }
}, s = {
  md: {
    width: 10,
    height: 5,
    borderRadius: "md",
    ":focus-visible::after": {
      borderRadius: "lg"
    }
  },
  lg: {
    width: 13,
    height: 7,
    borderRadius: "lg",
    ":focus-visible::after": {
      borderRadius: "xl"
    }
  }
}, a = {
  md: {
    size: (t) => t.spacing(3.5),
    '&[data-state="checked"]': {
      transform: (t) => `translateX(${t.spacing(5.75)})`
    }
  },
  lg: {
    size: (t) => t.spacing(5.5),
    '&[data-state="checked"]': {
      transform: (t) => `translateX(${t.spacing(6.75)})`
    }
  }
}, r = {
  switchSizes: s,
  switchThumbSizes: a
};
export {
  i as switchStyles,
  e as switchThumb,
  a as switchThumbSizes,
  r as switchesTheme
};
